var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"admin-fieldset",style:(_vm.borderColor ? `border-color: ${_vm.borderColor}` : '')},[(_vm.title)?_c('legend',{staticClass:"admin-legend",style:(_vm.legendColor ? `color: ${_vm.legendColor}` : '')},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }